import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../../components/Loader'

import { useTrainingCategory } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategory'
import AddTrainingCategory from './AddTrainingCategory'

export default function EditTrainingCategory() {
  const { trainingCategory, getTrainingCategory } = useTrainingCategory()
  const params = useParams()
  useEffect(() => {
    getTrainingCategory({ _id: params.trainingCategoryId })
  }, [params.trainingCategoryId])

  return <> {trainingCategory ? <AddTrainingCategory trainingCategory={trainingCategory} /> : <Loader />} </>
}
